module.exports = __webpack_public_path__ + "img/cadastro-website.8e6e39b4.png";